import React from 'react';
import { Section } from './ui/Section';
import { ArrowDown, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export default function ResultSection() {
  const steps = ['llega la noche,', 'ya no hay debate,', 'haces la descarga,', 'sigues el guión,', 'y si la noche es difícil… tienes Plan B.'];
  return <Section className="bg-brand-cream relative overflow-hidden" data-id="element-369">
      <div className="absolute inset-0 bg-gradient-to-t from-brand-indigo/5 to-transparent pointer-events-none" data-id="element-370" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-371">
        <h2 className="font-heading text-4xl md:text-5xl text-white mb-12 uppercase tracking-wide" data-id="element-372">
          Tu primer resultado real se siente así:
        </h2>

        <div className="space-y-6 mb-16" data-id="element-373">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.15
        }} className="flex flex-col items-center" data-id="element-374">
              <div className="flex items-center gap-3" data-id="element-375">
                <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} transition={{
              delay: index * 0.15 + 0.2,
              type: 'spring'
            }} className="bg-brand-indigo/15 p-1 rounded-full" data-id="element-376">
                  <Check size={16} className="text-brand-indigo" data-id="element-377" />
                </motion.div>
                <p className={`text-2xl md:text-3xl font-light ${index >= 3 ? 'text-slate-200' : 'text-slate-500'}`} data-id="element-378">
                  {step}
                </p>
              </div>
              {index < steps.length - 1 && <ArrowDown className="text-brand-indigo/40 my-2" size={24} data-id="element-379" />}
            </motion.div>)}
        </div>

        <motion.div whileHover={{
        scale: 1.02
      }} className="bg-brand-navy p-8 rounded-2xl border border-brand-indigo/20 shadow-lg hover:shadow-xl transition-all duration-500" data-id="element-380">
          <p className="text-2xl md:text-3xl text-slate-200 font-heading mb-4 uppercase tracking-wide" data-id="element-381">
            La emoción que aparece no es euforia.{' '}
            <span className="text-brand-indigo font-bold" data-id="element-382">Es alivio.</span>
          </p>
          <p className="text-xl text-slate-400" data-id="element-383">
            Ese «orgullo silencioso» de:{' '}
            <span className="text-slate-200 font-bold" data-id="element-384">
              «Esta vez no peleé. Y me dormí.»
            </span>
          </p>
        </motion.div>
      </div>
    </Section>;
}